// 평가 관리 화면 맨 위 제목 줄 (Jin 10/30) — [‹ 목록] 제목 · 배지 ……… 월 이동 · 버튼.
// 평가사 관리 · 평가사 정산 · 업체 정산(+ 업체 이용 내역)이 같은 줄을 쓰고, 그 아래에 요약(HeroStrip) → 목록(Card) 순.
// props: back {label, onClick} | null, title (노드), right (노드)
import React from 'react';
import { T, S, FONT } from '../../theme';

var wrap = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', marginBottom: 14, minHeight: 32 };
var left = { display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', minWidth: 0 };
var titleSt = { fontSize: 17, fontWeight: 800, color: T.navy, letterSpacing: '-.3px', margin: 0 };
var rightSt = { display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end', fontSize: FONT.body };
export var backStyle = Object.assign({}, S.btn, S.btnSm, { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress, fontWeight: 700 });

function PageBar(props) {
  return (<div className="v2-eval-pagebar" style={wrap}>
    <span style={left}>
      {props.back ? <button type="button" style={backStyle} onClick={props.back.onClick}>{props.back.label}</button> : null}
      {typeof props.title === 'string' ? <h2 style={titleSt}>{props.title}</h2> : <span style={Object.assign({}, titleSt, left)}>{props.title}</span>}
    </span>
    {props.right ? <span style={rightSt}>{props.right}</span> : null}
  </div>);
}

export default PageBar;
